import axios from "axios";
import API from "./API";
import Endpoints from "@/V3/Config/Endpoints";

export default {

    getStatus(centreID) {

        return axios.get(
            API.url(Endpoints.Sync.GetSyncStatus, {centre_id: centreID})
        ).then((res) => {
            return res.data;
        });

    },

    getManualSyncStatus(syncType, centreID, companyID) {

        return axios.get(
            API.url(Endpoints.Sync.GetManualSyncStatus, {sync_type: syncType, centre_id: centreID, company_id: companyID})
        ).then((res) => {
            return res.data;
        });

    },

    getLastManualSyncs(centreID) {

        return axios.get(
            API.url(Endpoints.Sync.GetLastManualSyncs, {centre_id: centreID})
        ).then((res) => {
            return res.data.syncs;
        });

    },

    requestManualCentreSync(centreID, syncType) {

        return axios.post(
            API.url(Endpoints.Sync.RequestManualCentreSync, {centre_id: centreID, sync_type: syncType})
        ).then((res) => {
            return res.data;
        });

    },

    requestManualCompanySync(centreID, companyID, syncType) {

        return axios.post(
            API.url(Endpoints.Sync.RequestManualCompanySync, {centre_id: centreID, company_id: companyID, sync_type: syncType})
        ).then((res) => {
            return res.data;
        });

    },

}
